// Normalizes any axios/DRF error into one human-readable string so VAPT
// screens show the backend's real message instead of the generic axios
// "Request failed with status code 400".
//
// Handles the response shapes this backend produces:
//   "text"                              (DRF ValidationError("text") -> ["text"])
//   ["text", ...]
//   {"error": "text"} / {"detail": "text"} / {"message": "text"}
//   {"field": ["text"], "other": ["text"]}   (serializer field errors)

const flatten = (value) => {
  if (value == null) return [];
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(flatten);
  if (typeof value === "object") return Object.values(value).flatMap(flatten);
  return [String(value)];
};

export const getVaptErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  const data = error?.response?.data;
  if (data) {
    if (typeof data === "object" && !Array.isArray(data)) {
      const direct = data.error || data.detail || data.message;
      if (typeof direct === "string" && direct.trim()) return direct;
    }
    const messages = flatten(data).filter((m) => typeof m === "string" && m.trim());
    if (messages.length) return Array.from(new Set(messages)).join(" ");
  }
  if (error?.code === "ERR_NETWORK") return "Cannot reach the server. Check your connection and try again.";
  return error?.message && !/^Request failed with status code/.test(error.message) ? error.message : fallback;
};
